import FingerprintJS from "@fingerprintjs/fingerprintjs";

export var DeviceInfoCallBack = {

    methods:{
        async getUniqueDeviceInfo() {
          const viewportWidth = window.innerWidth;
          var device = "";
          if (viewportWidth < 600) {
            // Mobile device
            device = "Mobile";
          } else if (viewportWidth >= 600 && viewportWidth < 1024) {
            // Tablet device
            device = "Tablet";
          } else {
            // Desktop device
            device = "Desktop";
          }
          // Initialize FingerprintJS
          const fpPromise = FingerprintJS.load();
          const fp = await fpPromise;
          // Get the visitor identifier and additional details
          const result = await fp.get();
          // Extract detailed information
          const components = result.components;
          var deviceInfo = {
            // device_unique_id: '123gghgad17721312hQAWEjdqad',
            device_unique_id: result.visitorId,
            platform: components.platform.value,
            timezone: components.timezone.value,
            device_type: device,
          };
      
          return deviceInfo;
        },
    }
};
